import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import Button from "components/CustomButtons/Button.js";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { saveUserLeadId } from "store/reducers/login/LoginSlice";
import brandTheme from "brandTheme/Theme";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import OtpModal from "views/components/OtpModal/OtpModal";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
    minHeight: "calc(100vh - 280px)"
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  verifyButton: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: 0,
  },
  nextButton3: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0px 40px",
    height: "55px",
    width: "8%",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
    "&:focus": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
  text:{
    fontSize: "20px",
    fontWeight: 600,
    color: brandTheme.primaryColor,
    marginTop: "20%",
    textAlign: "center",
  },
  button: {
    background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
  button2: {
    minWidth: "140px",
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
}));

const SanctionLetter = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const { authToken } = useSelector((state) => state.login.authData);
  const [fileLink, setFileLink] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const outletData = useOutletContext();
  const enableEstampFlag = parseAndSetFlag(outletData?.enableEstampFlag);
  const [modalOpen, setModalOpen] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const pdfSrc = isIOS
    ? `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(fileLink)}`
    : fileLink;
  useEffect(() => {
    if (location.state?.esignError) {
      toastUpdate("Error", location.state.esignError, true);
    
      // Clear the state so the toast doesn't appear again
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);
  useEffect(() => {
      getUserLoanDetails();
  }, []);

  const getUserLoanDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_LEAD_ALL_DOCUMENTS_API + leadId + "/documents",
      method: "GET",
      authToken: authToken,
    });
    console.log(result?.data, "API DATA");
    if (result?.data?.sanctionletter) {
      setFileLink(result?.data?.sanctionletter);
      setCallInProgress(false);
    } else {
      generateUserSanctionLetter();
    }
  };

  const generateUserSanctionLetter = async () => {
    const result = await apiHandler({
      url: endpoint.GENERATE_SANCTION_LETTER + leadId + "/part-a",
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.fileLink) {
      setFileLink(result?.data?.fileLink);
    }
  };

  const onClickEstamp = async () => {
    if(!enableEstampFlag){
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.USER_SANCTION_LETTER_ESIGN_API + leadId + '/part-a',
        method: "GET",
        authToken: authToken,
      });
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
        setCallInProgress(false);
      } else if (result?.data?.status === "COMPLETED") {
        setCallInProgress(false);
        navigate("/journey/EsignSanctionLetter");
      }else{
        const result = await apiHandler({
          url: endpoint.USER_SANCTION_LETTER_ESIGN_API + leadId + '/part-a',
          method:"POST",
          authToken: authToken,
          data:{
            redirectUrl: window.location.origin + "/eSign/sucess",
            errorUrl: window.location.origin + "/eSign/error",
          }
        });
        setCallInProgress(false);
        if(result?.data?.status === 'OTP_VALIDATION'){
          setTransactionId(result?.data?.transactionId);
          setModalOpen(true);
        }
        else if (result?.data?.signUrls && (result?.data?.signUrls?.[0]?.sign_url || result?.data?.signUrls?.[0]?.eSignUrl)) {
          window.location.href = result?.data?.signUrls?.[0]?.eSignUrl || result?.data?.signUrls?.[0]?.sign_url ;
          // navigate('/journey/EsignSanctionLetter');
        } else if (result?.data?.error_code) {
          toastUpdate("Error", result?.data?.user_description || "Something went wrong", true);
        }
      }
    }else{
      // setCallInProgress(true);
      // const result = await apiHandler({
      //   url: endpoint.USER_SANCTION_LETTER_ESTAAP_API + leadId + '/part-a',
      //   method:"POST",
      //   authToken: authToken,
      // });
      // setCallInProgress(false);
      // if(result?.data?.error_code) {
      //   toastUpdate("Error", result?.data?.user_description, true);
      // }else if(result?.data?.postEstampDocLink){
      navigate("/journey/EstampSanctionLetter");
      // }
    }
  };
  const openHtmlInNewTab = (url) => {
    window.open(url);
  };

  const handleOtpSubmit = async(otp) => {
    setCallInProgress(true);
    const result = await apiHandler({
          url: endpoint.USESR_VALIDATE_ESIGN_OTP_API,
          method:"POST",
          authToken: authToken,
          data:{
            txnId: transactionId,
            otp: otp,
          }
        });
    setCallInProgress(false);
    if(result?.data?.error_code) {
      setOtpError(result?.data?.user_description);
    }else{
      navigate("/journey/EsignSanctionLetter");
    }
  };
  const handleResendOtp = async(otp) => {
    setCallInProgress(true);
    const result = await apiHandler({
          url: endpoint.USESR_VALIDATE_ESIGN_RESEND_OTP_API + transactionId,
          method:"PUT",
          authToken: authToken,
        });
    setCallInProgress(false);
    if(result?.data?.error_code) {
      setOtpError(result?.data?.user_description);
    }else{
      toastUpdate("Success", "OTP Resent Successfully", true);
    }
  };
  return (
    <Grid container className={classes.container} style={{overflow:'hidden'}}>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Sanction Letter"
          button1={enableEstampFlag ? "E-stamp" : "E-sign"}
          button1click={onClickEstamp}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid xs={12} sm={12} md={12} style={{ position: "relative" }}>
            {pdfSrc !== "" ? (
              <iframe
                src={pdfSrc}
                style={{
                  width: "100%",
                  height: "80vh",
                  border: "none",
                  overflow: "auto",
                }}
              />
            ) : (
              <Grid xs={12} sm={12} md={12} className={classes.text}>Downloading Sanction Letter</Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid item xs={12} sm={12} md={12}>
        <BottomButton
          button1={enableEstampFlag ? "E-stamp" : "E-sign"}
          button1click={onClickEstamp}
        />
      </Grid> */}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {modalOpen &&
      <OtpModal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      onSubmit={handleOtpSubmit}
      onResendOtp={handleResendOtp}
      loading={callInProgress}
      error={otpError}
      classes={classes}
    />
    }
    </Grid>
  );
};

export default SanctionLetter;
